const cardsData = [
  {
    title: '明星后台花絮意外曝光',
    desc: '某顶流明星演唱会后台独家花絮流出，现场工作人员拍摄的罕见画面引发全网热议，粉丝疯狂转发。',
    tag: '明星八卦',
    heat: '18.6万',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20backstage%20atmosphere%20with%20warm%20stage%20lighting%2C%20mysterious%20silhouette%20of%20performer%2C%20dramatic%20shadows%2C%20dark%20theater%20background%2C%20professional%20concert%20photography%20style%2C%20cinematic%20mood%2C%20red%20and%20gold%20accents&width=600&height=400&seq=card-01-backstage&orientation=landscape',
  },
  {
    title: '综艺录制现场惊人对话',
    desc: '某热门综艺节目录制时被爆惊人对话内容，涉及多位知名艺人，节目组紧急发声明回应舆论质疑。',
    tag: '综艺热点',
    heat: '15.2万',
    img: 'https://readdy.ai/api/search-image?query=Television%20variety%20show%20studio%20set%20with%20colorful%20stage%20lights%2C%20entertainment%20production%20environment%2C%20professional%20broadcasting%20equipment%2C%20warm%20atmospheric%20lighting%2C%20modern%20TV%20production%20aesthetic&width=600&height=400&seq=card-02-variety&orientation=landscape',
  },
  {
    title: '网红圈最新争议事件梳理',
    desc: '近期网红圈接连爆出多起争议事件，从带货翻车到人设崩塌，一文梳理最新网红圈大事全貌。',
    tag: '网红动态',
    heat: '12.8万',
    img: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20content%20creation%20scene%2C%20modern%20studio%20with%20ring%20light%2C%20smartphone%20on%20tripod%2C%20trendy%20aesthetic%20background%2C%20warm%20ambient%20lighting%2C%20lifestyle%20photography%20style&width=600&height=400&seq=card-03-influencer&orientation=landscape',
  },
  {
    title: '年度最热影视剧槽点合集',
    desc: '年度热播剧集槽点大盘点，从穿帮镜头到剧情bug，网友犀利吐槽合集令人捧腹，导演回应了。',
    tag: '影视吐槽',
    heat: '11.5万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20production%20scene%20with%20dramatic%20lighting%2C%20movie%20director%20chair%20on%20set%2C%20professional%20camera%20equipment%2C%20dark%20atmospheric%20studio%2C%20Hollywood%20style%20cinematography%20aesthetic&width=600&height=400&seq=card-04-drama&orientation=landscape',
  },
  {
    title: '音乐圈抄袭风波再升级',
    desc: '知名歌手新歌被指抄袭海外作品，乐评人逐帧对比分析，两首歌曲相似度惊人，粉丝阵营激烈交锋。',
    tag: '音乐话题',
    heat: '10.3万',
    img: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20professional%20microphone%2C%20warm%20acoustic%20panels%2C%20dark%20moody%20atmosphere%2C%20vinyl%20records%20on%20shelf%2C%20creative%20artist%20workspace%2C%20sound%20engineering%20aesthetic&width=600&height=400&seq=card-05-music&orientation=landscape',
  },
  {
    title: '体育圈退役明星近况追踪',
    desc: '多位退役体育明星最新近况曝光，有人转型成功身家过亿，有人陷入经济困境，命运天差地别。',
    tag: '体育八卦',
    heat: '9.7万',
    img: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20empty%20arena%20seats%2C%20spotlight%20on%20field%2C%20professional%20sports%20photography%20style%2C%20dark%20moody%20ambiance%2C%20athletic%20aesthetic&width=600&height=400&seq=card-06-sports&orientation=landscape',
  },
  {
    title: '短视频平台政策大调整',
    desc: '主流短视频平台发布最新内容审核政策，多类视频内容面临下架风险，创作者纷纷调整内容策略。',
    tag: '平台动态',
    heat: '8.4万',
    img: 'https://readdy.ai/api/search-image?query=Modern%20digital%20media%20interface%20with%20glowing%20screens%2C%20smartphone%20displaying%20video%20content%2C%20dark%20tech%20workspace%2C%20neon%20accent%20lights%2C%20futuristic%20social%20media%20aesthetic&width=600&height=400&seq=card-07-platform&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门精选</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            每日精选最热门、最具话题性的黑料内容，一站式掌握全网热点
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.map((card, idx) => (
            <article
              key={idx}
              className="group bg-background-100 border border-background-300/40 rounded-xl overflow-hidden transition-all hover:border-primary-500/30 hover:bg-background-200/50 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading={idx < 4 ? undefined : 'lazy'}
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-1">
                  <i className="ri-eye-line text-xs text-foreground-600"></i>
                  <span className="text-xs text-foreground-500">{card.heat}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}